import { isDefined } from "@utils/helpers";

import { MAX_STORES_LIST } from "../storeSearch.config";
import { enrichStores } from "../storeSearch.helpers";
import { StoreUrl } from "../storeSearch.types";
import { findStoreById } from "./findStoreById.query";

export const findStoresByStore = async (
    StoresService: woosmap.map.StoresService,
    storeUrls: Array<StoreUrl>,
    storeId: string,
    tags: Array<string>,
    locale: string,
) => {
    const query = [
        `user.locale:="${locale}"`,
        ...tags.map(tag => `tag:"${tag}"`),
    ].join(" AND ");

    const centerStore = await findStoreById(StoresService, storeId, locale);

    if (!isDefined(centerStore))
        return {
            stores: [],
            query: query,
        };

    const storesResponse = await StoresService.search({
        latLng: {
            lat: centerStore.geometry.coordinates[1],
            lng: centerStore.geometry.coordinates[0],
        },
        query: query,
        storesByPage: MAX_STORES_LIST,
    });

    const stores = enrichStores(storesResponse.features ?? [], storeUrls);

    return {
        stores: stores,
        query: query,
    };
};
